import { useState } from "react";

interface UseLoadingProps {
	defaultIsLoading?: boolean;
}

/**
 * This hook manages a loading state.
 * It provides functions to start and stop the loading state.
 * @returns
 */
export function useLoading(props?: UseLoadingProps) {
	/** State */
	const [isLoading, setIsLoading] = useState(props?.defaultIsLoading ?? false);

	/** Functions */
	function start() {
		setIsLoading(true);
	}

	function stop() {
		setIsLoading(false);
	}

	/** Return */
	return {
		isLoading,
		start,
		stop,
	};
}

export type UseLoading = ReturnType<typeof useLoading>;
